module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BW-d9f01c5c8e273afd71a82449c2055808.png";